import de from "./de/world.js";
import en from "./en/world.js";
import es from "./es/world.js";
import it from "./it/world.js";
import pl from "./pl/world.js";
import cz from "./cs/world.js";
import fr from "./fr/world.js";

export default {de, en, es, it, pl, cz, fr};
